import { render, staticRenderFns } from "./PSampleProfile.vue?vue&type=template&id=fea2bd8a&scoped=true&"
import script from "./PSampleProfile.vue?vue&type=script&lang=ts&"
export * from "./PSampleProfile.vue?vue&type=script&lang=ts&"
import style0 from "./PSampleProfile.vue?vue&type=style&index=0&id=fea2bd8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea2bd8a",
  null
  
)

export default component.exports